/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesProbabilities.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Probability Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, January 21, 2019 - 03:55:55 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      01/21/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const ProbabilityList = Loadable({
    loader: () => import('../containers/Probabilities/ProbabilityListContainer'),
    loading: Loading,
});

export const ProbabilityForm = Loadable({
    loader: () => import('../containers/Probabilities/ProbabilityEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesProbabilities.js